<template>
  <section class="home">
    <div class="home__banner">
      <div class="layer" />
      <div class="content">
        <div class="home__wrap">
          <h1 class="title">{{texts.texto1}}</h1>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="home__box">
        <p class="text pb-text-color">
          {{texts.texto2}}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Home',
  computed: {
    ...mapState(['texts'])
  }
}
</script>

<style lang="scss" scoped>
.home {
  &__banner {
    position: relative;
    background: url('/static/imagen-principal.jpg') center no-repeat;
    background-size: cover;

    .layer {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background: rgba(0,0,0,.5);
    }
  }

  &__box {
    padding: 0 60px;
    margin: 40px 0;
  }

  &__wrap {
    min-height: calc(100vh - 48px - 113px);
    min-height: 650px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
    color: #fff;
  }

  .title {
    text-align: center;
    font-size: 3em;
  }

  .subtitle {
    color: gray;
    margin-top: 30px;
    margin: 0;
  }

  .text {
    color: gray;
    margin-bottom: 16px;
  }
}
</style>
